import {AfterViewInit, Component, OnDestroy, ViewChild} from '@angular/core';
import {LuminariaService} from '../../services/luminaria.service';
import {luminaria} from '../../models/luminaria';
import {zona} from '../../models/zona';
import {Localiser} from '../../services/localiser';
import {ZonaService} from '../../services/zona.service';
import {concentrador} from '../../models/concentrador';
import {PlanoService} from "../../services/plano.service";
import {Navigation} from "../../services/navigation.service";
import {UserService} from "../../services/user.service";
import {DeviceService} from "../../services/device.service";
import {ProyectoService} from "../../services/proyecto.service";
import {ImageOptionsComponent} from "./image-options/image-options.component";
import {MatDialog} from "@angular/material/dialog";
import {imagen} from "../../models/imagen";
import {ImagesService} from "../../services/images.service";
import {ImagenesLuminariaService} from "../../services/imagenes-luminaria.service";
import {imagenesModeloLuminaria} from "../../models/imagenesModeloLuminaria";
import {imagenesLuminaria} from "../../models/imagenesLuminaria";
import {Model, modelList, SubIcon} from '../../commons/util';

class imageClass {
  name: string = undefined;
  image = new Image();
  loaded: boolean = false;

  constructor(name: string, imageSrc: string) {
    this.name = name;
    this.image.src = imageSrc;
    let that = this;
    this.image.onload = function () {
      that.loaded = true;
    }
  }

  getName() {
    return this.name;
  }

  getImage() {
    return this.image;
  }

  isLoaded() {
    return this.loaded;
  }

}

@Component({
  selector: 'app-floorplans',
  templateUrl: './floorplans.component.html',
  styleUrls: ['./floorplans.component.css']
})
export class FloorplansComponent implements AfterViewInit, OnDestroy {
  @ViewChild('elementsBackground', {static: false}) public canvasEB: any;
  public canvasEleBack: any;
  ctxEleBack;

  @ViewChild('background', {static: false}) public canvasB: any;
  public canvasBack: any;
  ctxBack;
  movePlano = false;
  moveCX;
  moveCY;
  totalMoveX = 0;
  totalMoveY = 0;

  backImage;
  image = new Image();
  imagesLums: imageClass[] = [];
  imagesSubIcon: imageClass[] = [];
  matrix = [1,0,0,1,0,0];
  scale = 10;
  scaleFactor = 1;
  widthLum = 1;
  heightLum = 1;
  ratioImageHeight = 1000;
  ratio = 0;
  imageLoaded = false;
  firstTimeImage = true;
  luminariasLoaded = false;

  zonas: Array<zona> = [];
  concentradores: Array<concentrador> = [];
  luminarias: Array<luminaria> = [];
  luminariasReal: Array<luminaria> = [];
  luminariasMap: Array<luminaria> = [];
  searcherLuminarias: string = "";

  selectedZona: zona = null;
  selectedLum: luminaria = null;
  selectedCon: concentrador = null;
  valid = false;
  validImage = false;
  dragging = false;
  draggingCon = false;
  dragOffX = 0;
  dragOffY = 0;

  argBlinkLuminaria: number = 0;
  argPowerLuminaria: number = 0;
  planoSelected = null;

  autoSaveInterval;

  imagesByEmpresa: imagen[] = [];
  imagenesModeloByEmpresa: imagenesModeloLuminaria[] = [];
  modeloLuminariaSelected: imagenesModeloLuminaria = undefined;
  modelLuminariaSelected: Model = undefined;

  imagesPath = 'assets/img/models_led/';
  subIconValues = Object.values(SubIcon);
  missing = new Image();
  generic = new Image();

  adjustFactor = 0.50;
  adjustWidth = 1056;
  adjustHeight = 519;

  errorMap: Map<string, boolean> = new Map();

  constructor(public localiser: Localiser, private luminariaService: LuminariaService,
              private zonaService: ZonaService, public proyectoService: ProyectoService,
              public planoService: PlanoService, private navigation: Navigation,
              public user: UserService, private deviceService: DeviceService,
              public matDialog: MatDialog, public imagesService: ImagesService,
              public imagenesLuminariaService: ImagenesLuminariaService) {
    if (!this.proyectoService.proyectoActualCookie()) {
      this.proyectoService.setTrueSelectALocation("floorplans");
      this.navigation.toLocations();
    } else {
      this.proyectoService.setLastPage("floorplans");
      if (this.planoService.getPlanoSelected() == null) {
        this.navigation.toSelectFloorplan();
      } else {
        this.planoSelected = this.planoService.getPlanoSelected();
        this.autoSaveInterval = setInterval(() => {
          this.checkValidDraws();
        }, 15);
      }
    }

    let that = this;
    window.addEventListener('resize', (function() {
      return that.restartFloorplan();
    }));
  }

  restart() {
    this.restartFloorplan();
    this.restartImages();
  }

  restartFloorplan() {
    this.matrix = [1,0,0,1,0,0];
    this.scale = 10;
    this.scaleFactor = 1;
    this.selectedLum = null;
    this.modeloLuminariaSelected = undefined;
    this.modelLuminariaSelected = undefined;
    this.luminariasLoaded = false;
    this.imageLoaded = false;
    this.firstTimeImage = true;
    this.validImage = false;
    this.prepareCanvasBack();
    this.prepareCanvasEleBack();
  }

  restartImages() {
    this.getImagesByEmpresa();
    this.getImagenesModeloByEmpresa();
  }

  ngAfterViewInit(): void {
    this.prepareCanvasBack();
    this.prepareCanvasEleBack();
    this.getImagesByEmpresa();
    this.getImagenesModeloByEmpresa();

    this.missing.src = this.imagesPath + 'missing.svg';
    this.generic.src = this.imagesPath + 'generic.svg';
  }

  ngOnDestroy() {
    clearInterval(this.autoSaveInterval);
  }

  goToSelectPlano() {
    this.navigation.toSelectFloorplan();
  }

  goToInfoLuminaria(luminaria: luminaria) {
    this.deviceService.setSelectedLuminaria(luminaria);
    this.navigation.toDevices();
  }

  prepareCanvasBack() {
    try {
      this.canvasBack = this.canvasB.nativeElement;
      this.ctxBack = this.canvasBack.getContext("2d");
      this.ctxBack.canvas.width  = window.innerWidth * 0.55;
      this.ctxBack.canvas.height = window.innerHeight * 0.55;
    } catch (e) {
      return 0;
    }
    let ctxThis = this;
    /*this.image.onload = function() {
      ctxThis.ctxBack.clearRect(-100000, -100000, 1000000, 1000000);

      // FULL HORIZONTAL SIZE
      let hRatio = ctxThis.canvasBack.width / ctxThis.image.width;
      ctxThis.ctxBack.drawImage(ctxThis.image, 0,0, ctxThis.image.width, ctxThis.image.height,
        0, 0, ctxThis.image.width * hRatio, ctxThis.image.height * hRatio);

      // STORE IMAGE VERTICAL RATIO FOR DRAW LUMINAIRES
      ctxThis.ratioImageHeight = ctxThis.image.width * ctxThis.ctxBack.canvas.width / ctxThis.image.height;

      ctxThis.imageLoaded = true;
      ctxThis.validImage = true;
      ctxThis.valid = false;
    }*/
    this.image.onload = function () {
      ctxThis.ctxBack.clearRect(-100000, -100000, 1000000, 1000000);

      // Calculate aspect-fit scale
      const hRatio = ctxThis.canvasBack.width / ctxThis.image.width;
      const vRatio = ctxThis.canvasBack.height / ctxThis.image.height;
      const ratio = Math.min(hRatio, vRatio);
      ctxThis.ratio = ratio;


      ctxThis.ctxBack.drawImage(
        ctxThis.image,
        0, 0, ctxThis.image.width, ctxThis.image.height,
        0, 0,
        ctxThis.image.width * ratio, ctxThis.image.height * ratio
      );

      //ctxThis.ratioImageHeight = ratio;
      ctxThis.imageLoaded = true;
      ctxThis.validImage = true;
      ctxThis.valid = false;
    };

    this.backImage = '' + this.planoService.getPlanoSelected().imagenPlano;
    this.image.src = this.backImage;

  }

  loadImagesLums() {
    for (let model of modelList) {
      const imagePath = this.imagesPath + model.svg + '.svg';
      const imageId = model.id;
      const img = new imageClass(imageId, imagePath);
      this.imagesLums.push(img);
    }
  }

  loadImagesSubIcon() {
    this.subIconValues.forEach(subIcon => {
      const imagePath = this.imagesPath + subIcon + '.svg';
      const imageId = subIcon;
      const img = new imageClass(imageId, imagePath);
      this.imagesSubIcon.push(img);
    });
  }

/*
  moveCanvasBack() {
    this.ctxBack.clearRect(-100000, -100000, 1000000, 1000000);

    // FULL HORIZONTAL SIZE
    let hRatio = this.canvasBack.width / this.image.width;
    this.ctxBack.drawImage(this.image, 0,0, this.image.width, this.image.height,
      0, 0, this.image.width * hRatio, this.image.height * hRatio);

    // STORE IMAGE VERTICAL RATIO FOR DRAW LUMINAIRES
    this.ratioImageHeight = this.image.width * this.ctxBack.canvas.width / this.image.height;

    this.imageLoaded = true;
    this.validImage = true;
    this.valid = false;
  }
 */

  searchImageLumById(luminaria: luminaria) {
    const imageId = luminaria.ledModelo;
    for (let image of this.imagesLums) {
      if (imageId == image.getName()) {
        if(image.isLoaded()) {
          return image.getImage();
        } else {
          return this.missing;
        }
      }
    }
    return this.generic;
  }

  searchSubIconImage(luminaria: luminaria) {
    const subIcon = this.calculateLumSubIcon(luminaria);

    if(subIcon === null) {
      return null;
    }

    const imageId = subIcon;
    for (let image of this.imagesSubIcon) {
      if (imageId === image.getName() && image.isLoaded()) {
        return image.getImage();
      }
    }
    return this.missing;
  }

  prepareCanvasEleBack() {
    try {
      this.canvasEleBack = this.canvasEB.nativeElement;
      this.ctxEleBack = this.canvasEleBack.getContext("2d");
      this.ctxEleBack.canvas.width = window.innerWidth * 0.55;
      this.ctxEleBack.canvas.height = window.innerHeight * 0.55;
    } catch (e) {
      return 0
    }

    this.getLuminarias();
  }


  draw(ctx, luminaria: luminaria) {
    const degrees = luminaria.rotacion;
    const radians = degrees * Math.PI / 180;

    const imgSrc = this.searchImageLumById(luminaria);
    const subIconImgSrc = this.searchSubIconImage(luminaria);

    const { width: imgWidth, height: imgHeight } = this.calculateImageSizeForLuminaria(luminaria);

    const centerX = luminaria.posicion_x + imgWidth / 2;
    const centerY = luminaria.posicion_y + imgHeight / 2;

    ctx.save();
    ctx.translate(centerX, centerY);
    ctx.rotate(radians);


    ctx.drawImage(
      imgSrc,
      -imgWidth / 2,
      -imgHeight / 2,
      imgWidth,
      imgHeight
    );

    if (subIconImgSrc !== null) {
      const overlaySize = Math.max(imgWidth, imgHeight) * 0.2;

      const offsetX = -imgWidth / 2 + imgWidth * 0.75;
      const offsetY = -imgHeight / 2;

      const rotatedX = offsetX * Math.cos(radians) - offsetY * Math.sin(radians);
      const rotatedY = offsetX * Math.sin(radians) + offsetY * Math.cos(radians);

      ctx.rotate(-radians);

      ctx.drawImage(
        subIconImgSrc,
        rotatedX - overlaySize / 2,
        rotatedY - overlaySize / 2,
        overlaySize,
        overlaySize
      );
    }

    ctx.restore();
  }

  drawLuminarias(ctx, luminarias: luminaria[]) {
    for (let luminaria of luminarias) {
      this.draw(this.ctxEleBack, luminaria);
    }

    // Draw selected luminaria
    if (this.selectedLum != null && this.selectedLum.idPlano != "-1") {
      const { width: imgWidth, height: imgHeight } = this.calculateImageSizeForLuminaria(this.selectedLum);

      const degrees = this.selectedLum.rotacion;
      const radians = degrees * Math.PI / 180;

      const centerX = this.selectedLum.posicion_x + imgWidth / 2;
      const centerY = this.selectedLum.posicion_y + imgHeight / 2;

      const padding = 2;

      ctx.save();
      ctx.translate(centerX, centerY);
      ctx.rotate(radians);

      ctx.strokeStyle = 'green';
      ctx.lineWidth = 5;
      ctx.strokeRect(
        -imgWidth / 2 - padding,
        -imgHeight / 2 - padding,
        imgWidth + padding * 2,
        imgHeight + padding * 2
      );

      ctx.restore();
    }
  }

  checkValidDraws() {

    if (this.imageLoaded && this.luminariasLoaded) {
      if (this.firstTimeImage) {
        this.addLuminariasToMap();
        this.firstTimeImage = false;
      }

      if (!this.validImage) {
        this.image.src = this.backImage;
        //this.moveCanvasBack();
        this.imageLoaded = false;
      } else {
        if (!this.valid) {
          this.drawShapes(this.ctxEleBack);
        }
      }

    }

  }

  drawShapes(ctx) {
    ctx.clearRect(-100000, -100000, 1000000, 1000000);
    this.drawLuminarias(ctx, this.luminariasMap);
    this.valid = true;
  }

  wheelEvent(ev) {
    ev.preventDefault();
    this.zoom(ev.wheelDeltaY);
  }

  zoom(y) {
    if (y < 0) {
      if (this.scale > 1) {
        this.scale = this.scale - 1;
        this.scaleFactor /= 1.1;
        this.scaleCanvas(0.909090, 0.909090);
      }
    } else if (y > 0) {
      this.scale = this.scale + 1;
      this.scaleFactor *= 1.1;
      this.scaleCanvas(1.1, 1.1);
    }

    if (this.scale > 10) {
      this.scaleFactor = 0.909090 ** (this.scale - 10);
    } else if (this.scale < 10) {
      this.scaleFactor = (1.1 ** (10 - this.scale));
    } else if (this.scale == 10) {
      this.scaleFactor = 1;
    }
    this.matrix[4] = this.totalMoveX * this.scaleFactor;
    this.matrix[5] = this.totalMoveY * this.scaleFactor;
    this.validImage = false;
    this.valid = false;
  }

  start(ev) {
    let x = (ev.x - window.innerWidth*0.19) * this.scaleFactor - this.matrix[4];
    let y = (ev.y - window.innerHeight*0.19) * this.scaleFactor - this.matrix[5];

    if (!this.movePlano && ev.buttons !== 2) {
      for (let luminaria of this.luminariasMap) {
        const { width: imgWidth, height: imgHeight } = this.calculateImageSizeForLuminaria(luminaria);
        const degrees = luminaria.rotacion;
        const radians = degrees * Math.PI / 180;

        const centerX = luminaria.posicion_x + imgWidth / 2;
        const centerY = luminaria.posicion_y + imgHeight / 2;

        const dx = x - centerX;
        const dy = y - centerY;

        const rotatedX = dx * Math.cos(-radians) - dy * Math.sin(-radians);
        const rotatedY = dx * Math.sin(-radians) + dy * Math.cos(-radians);

        if (
          rotatedX >= -imgWidth / 2 && rotatedX <= imgWidth / 2 &&
          rotatedY >= -imgHeight / 2 && rotatedY <= imgHeight / 2
        ) {
          this.selectedLum = luminaria;
          this.setModeloByImagenesLuminaria(luminaria.imagenesLuminaria);
          this.setModelByImagenesLuminaria(luminaria.ledModelo);
          this.selectedZona = null;

          this.dragOffX = rotatedX + imgWidth / 2;
          this.dragOffY = rotatedY + imgHeight / 2;

          this.dragging = true;
          this.valid = false;
          return;
        }
      }

      for (let concentrador of this.concentradores) {
        if (x > concentrador.posicion_x - 20 && x < concentrador.posicion_x + 20 && y > concentrador.posicion_y - 20 && y < concentrador.posicion_y + 20) {
          this.selectedCon = concentrador;
          this.selectedLum = null;
          this.modeloLuminariaSelected = undefined;
          this.modelLuminariaSelected = undefined;
          this.selectedZona = null;
          this.dragOffX = x - concentrador.posicion_x;
          this.dragOffY = y - concentrador.posicion_y;
          this.draggingCon = true;
          this.valid = false;
          return;
        }
      }
    } else {
      x = ev.x - window.innerWidth*0.19;
      y = ev.y - window.innerHeight*0.19;
      this.dragging = true;
      this.moveCX = x;
      this.moveCY = y;
    }
    if (this.selectedLum != null || this.selectedZona != null) {
      this.selectedLum = null;
      this.modeloLuminariaSelected = undefined;
      this.modelLuminariaSelected = undefined;
      this.selectedCon = null;
      this.selectedZona = null;
      this.valid = false;
    }

  }

  move(ev) {
    if (this.dragging && (ev.buttons !== 2 && !this.movePlano) && this.user.getPermiso() != "Ateneo"){
      let x = (ev.x - window.innerWidth*0.19) * this.scaleFactor - this.matrix[4];
      let y = (ev.y - window.innerHeight*0.19) * this.scaleFactor - this.matrix[5];

      this.selectedLum.posicion_x = x - this.dragOffX;
      this.selectedLum.posicion_y = y - this.dragOffY;
      this.valid = false;
    } else if (this.draggingCon){
      let x = (ev.x - window.innerWidth*0.19) * this.scaleFactor - this.matrix[4];
      let y = (ev.y - window.innerHeight*0.19) * this.scaleFactor - this.matrix[5];

      this.selectedCon.posicion_x = x - this.dragOffX;
      this.selectedCon.posicion_y = y - this.dragOffY;
      this.valid = false;
    } else if (this.dragging && (ev.buttons === 2 || this.movePlano)) {
      let x = ev.x - window.innerWidth * 0.19;
      let y = ev.y - window.innerHeight * 0.19;
      this.totalMoveX += x - this.moveCX;
      this.totalMoveY += y - this.moveCY;
      this.matrix[4] = this.totalMoveX * this.scaleFactor;
      this.matrix[5] = this.totalMoveY * this.scaleFactor;
      this.translateCanvas(x - this.moveCX, y - this.moveCY);
      this.validImage = false;
      this.valid = false;
      this.moveCX = x;
      this.moveCY = y;
    }
  }

  end() {
    this.dragging = false;
    this.draggingCon = false;
    if (this.selectedLum != null) {
      this.updateLuminariaOnMap(this.selectedLum);
    }
  }

  translateCanvas(x, y) {
    this.matrix[4] +=x;
    this.matrix[5] +=y;
    this.ctxBack.translate(x*this.scaleFactor, y*this.scaleFactor);
    this.ctxEleBack.translate(x*this.scaleFactor, y*this.scaleFactor);
  }

  scaleCanvas(x, y) {
    this.matrix[0] *= x;
    this.matrix[1] *= x;
    this.matrix[2] *= y;
    this.matrix[3] *= y;
    this.ctxBack.scale(x, y);
    this.ctxEleBack.scale(x, y);
  }

  changeMovePlano() {
    this.movePlano = !this.movePlano;
  }

  returnMovePlano() {
    this.matrix = [1,0,0,1,0,0];
    this.ctxBack.setTransform(this.matrix);
    this.ctxEleBack.setTransform(this.matrix);
    this.totalMoveX = 0;
    this.totalMoveY = 0;
    this.scale = 10;
    this.scaleFactor = 1;
    this.validImage = false;
    this.valid = false;
  }

  // cmd: blink (text)
  // arg: secs (number)
  blinkLuminaire() {
    let json =
      {
        "idDispositivo": this.selectedLum.idDispositivo,
        "cmd": "blink",
        "arg": this.argBlinkLuminaria
      };
    this.luminariaService.sendOrden(json);
  }

  // cmd: power (text)
  // arg: perc% (number)
  powerLuminaire() {
    let json =
      {
        "idDispositivo": this.selectedLum.idDispositivo,
        "cmd": "power",
        "arg": this.argPowerLuminaria
      };
    this.luminariaService.sendOrden(json);
  }

  selectLum(luminaria: luminaria) {
    this.selectedLum = luminaria;
    this.setModeloByImagenesLuminaria(luminaria.imagenesLuminaria);
    this.setModelByImagenesLuminaria(luminaria.ledModelo)
    this.selectedZona = null;
    this.valid = false;
  }

  selectZona(zona: zona) {
    this.selectedZona = zona;
    this.selectedLum = null;
    this.modeloLuminariaSelected = undefined;
    this.modelLuminariaSelected = undefined;
    this.valid = false;
  }

  getLuminarias() {
    this.luminarias = [];
    this.luminariaService.getByIdPlano(this.planoService.getPlanoSelected().idPlano).subscribe((response) => {
      this.luminariasReal = <Array<luminaria>> response;
      this.luminarias = this.luminariasReal;

      let offsetY = 0.02 * this.planoSelected.escalaLuminarias;
      const spacingFactor = 0.2;

      this.luminarias.forEach((lum) => {
        if (lum.posicion_x === 0 && lum.posicion_y === 0) {
          lum.posicion_x = 0.02 * this.planoSelected.escalaLuminarias;

          const { height: imgHeight } = this.calculateImageSizeForLuminaria(lum);

          lum.posicion_y = offsetY;

          offsetY += imgHeight  * spacingFactor;
        }

        this.luminariaService.getIsErrorDaliDataByLuminaria(lum.idDispositivo)
          .subscribe((hasError: boolean) => {
            this.errorMap.set(lum.idDispositivo, hasError);
          });
      });

      this.getZonas();
    });
  }

  updateLuminariaOnMap(luminaria: luminaria) {
    let idZona = luminaria.idZona;
    for (let zona of this.zonas) {
      if (luminaria.idZona == zona.nombre) {
        idZona = zona.id;
      }
    }
    let refactorX = (luminaria.posicion_x + (this.widthLum / 2)) / this.ratio;
    let refactorY = (luminaria.posicion_y + (this.heightLum / 2)) / this.ratio; //this.ratioImageHeight;
    this.luminariaService.mapUpdate(luminaria.idDispositivo, luminaria.nombre, luminaria.idPlano, refactorX, refactorY,
      idZona).subscribe(result => { });
    this.valid = false;
  }

  updateRotacion() {
    this.selectedLum.rotacion = (this.selectedLum.rotacion + 45) % 360;
    this.luminariaService.updateRotacion(this.selectedLum.idDispositivo, this.selectedLum.rotacion).subscribe(result => { });
    this.valid = false;
  }

  resetPosicionLuminaria() {
    this.selectedLum.posicion_x = 0;
    this.selectedLum.posicion_y = 0;

    let idZona = this.selectedLum.idZona;
    for (let zona of this.zonas) {
      if (this.selectedLum.idZona == zona.nombre) {
        idZona = zona.id;
      }
    }
    this.luminariaService.mapUpdate(this.selectedLum.idDispositivo, this.selectedLum.nombre, this.selectedLum.idPlano, this.selectedLum.posicion_x, this.selectedLum.posicion_y,
      idZona).subscribe(result => { });
    this.valid = false;
  }

  addLuminariasToMap() {
    //this.widthLum = this.ctxEleBack.canvas.width * this.planoSelected.escalaLuminarias / this.planoSelected.metrosPlano;
    //this.heightLum = this.ctxEleBack.canvas.height * this.planoSelected.escalaLuminarias / this.planoSelected.metrosPlano;

    // This is for draw an image
    let diffWH = 1;
    //this.widthLum = this.ctxEleBack.canvas.width * this.planoSelected.escalaLuminarias / this.planoSelected.metrosPlano * diffWH;
    //this.heightLum = this.ctxEleBack.canvas.height * this.planoSelected.escalaLuminarias / this.planoSelected.metrosPlano / diffWH;
    this.widthLum = this.planoSelected.escalaLuminarias / this.planoSelected.metrosPlano;
    this.heightLum = this.planoSelected.escalaLuminarias / this.planoSelected.metrosPlano;
    this.luminariasMap = this.luminariasReal.slice();
    this.luminariasMap.forEach(luminaria => {
      luminaria.posicion_x = (luminaria.posicion_x * this.ratio) - (this.widthLum / 2);
      luminaria.posicion_y = (luminaria.posicion_y * this.ratio) - (this.heightLum / 2);
    });
    this.validImage = false;
    this.valid = false;
  }

  getZonas() {
    this.zonaService.getByIdPlano(this.planoService.getPlanoSelected().idPlano).subscribe((response) => {
      this.zonas = <Array<zona>> response;
      this.luminariasLoaded = true;
    });
  }

  getZonaOfLuminaria(luminaria: luminaria) {
    for (let zona of this.zonas) {
      if (zona.id == luminaria.idZona) {
        return zona;
      }
    }
    return undefined;
  }

  searcherLuminariasFunc() {
    this.luminarias = this.luminariasReal.filter(luminaria =>
      (luminaria.nombre.toLowerCase().includes(this.searcherLuminarias.toLowerCase())) ||
      (luminaria.idDispositivo.toLowerCase().includes(this.searcherLuminarias.toLowerCase())));
  }

  maxLengthCheckBlink(event) {
    if (event.target.value.length > event.target.max.length) {
      let number = event.target.value.slice(0, event.target.max.length);
      event.target.value = +number;
      this.argBlinkLuminaria = +number;
    }
  }

  maxLengthCheckPower(event) {
    if (event.target.value.length > event.target.max.length) {
      let number = event.target.value.slice(0, event.target.max.length);
      event.target.value = +number;
      this.argPowerLuminaria = +number;
    }
  }

  checkPeripheralLum(lum: luminaria, peripheral: string) {
    if (lum.perifericos != null) {
      if (peripheral == "emg") {
        if (lum.perifericos.emg != -1) {
          return this.localiser.get("devices.yes");
        } else {
          return this.localiser.get("devices.no");
        }
      } else if (peripheral == "presence") {
        if (lum.perifericos.klc != -1 || lum.perifericos.dfrobot != -1 || lum.perifericos.innosent != -1 || lum.perifericos.ekmc != -1) {
          return this.localiser.get("devices.yes");
        } else {
          return this.localiser.get("devices.no");
        }
      } else if (peripheral == "420") {
        if (lum.perifericos.h420 != -1) {
          return this.localiser.get("devices.yes");
        } else {
          return this.localiser.get("devices.no");
        }
      }
    } else {
      return this.localiser.get("peripherals.noData");
    }
  }

  updatePlano() {
    this.planoService.updateMetrosEscala(this.planoSelected).subscribe(result => { });
    this.restartFloorplan();
  }

  getImagesByEmpresa() {
    this.imagesService.getImagenesByEmpresa(this.proyectoService.getProyectoActual().idEmpresa).subscribe((result: imagen[]) => {
      this.valid = false;
      this.imagesByEmpresa = result;
      this.loadImagesLums();
      this.loadImagesSubIcon();
    })
  }

  getImagenesModeloByEmpresa() {
    this.imagenesLuminariaService.getModelosByIdEmpresa(this.proyectoService.getProyectoActual().idEmpresa).subscribe((result: imagenesModeloLuminaria[]) => {
      this.valid = false;
      this.imagenesModeloByEmpresa = result;
    })
  }

  openOptions() {
    let dialog = this.matDialog.open(ImageOptionsComponent, {
      width: '70%',
      height: '85%',
      data: {images: this.imagesByEmpresa, modelos: this.imagenesModeloByEmpresa}
    });

    dialog.afterClosed().subscribe((action: boolean) => {
      if (action) {
        this.restart();
      }
    });
  }

  setModeloByImagenesLuminaria(imagenesLuminaria: imagenesLuminaria) {
    if (imagenesLuminaria != undefined && imagenesLuminaria.model != "-1") {
      this.modeloLuminariaSelected = this.imagenesModeloByEmpresa.find(modelo => modelo.idModelo == imagenesLuminaria.model);
    } else {
      this.modeloLuminariaSelected = undefined;
    }
  }

  setModelByImagenesLuminaria(ledModelo: string) {
    if (ledModelo != undefined && ledModelo != "0") {
      this.modelLuminariaSelected = modelList.find(model => model.id == ledModelo);
    } else {
      this.modelLuminariaSelected = undefined;
    }
  }

  changeModeloLuminaria(modelo: imagenesModeloLuminaria) {
    if (modelo != undefined) {
      this.selectedLum.imagenesLuminaria.model = modelo.idModelo;
      this.setModeloByImagenesLuminaria(this.selectedLum.imagenesLuminaria);
      this.imagenesLuminariaService.assignModelo(this.selectedLum.idDispositivo, modelo.idModelo).subscribe(result => {
        //this.restartImages();
        this.valid = false;
      });
    } else {
      this.selectedLum.imagenesLuminaria.model = "-1";
      this.setModeloByImagenesLuminaria(undefined);
      this.imagenesLuminariaService.assignModelo(this.selectedLum.idDispositivo, "-1").subscribe(result => {
        //this.restartImages();
        this.valid = false;
      });
    }
  }

  changeModelLuminaria(model: Model) {
    if (model != undefined) {
      this.selectedLum.ledModelo = model.id;
      this.setModelByImagenesLuminaria(model.id);
      this.luminariaService.updateLedModelo(this.selectedLum.idDispositivo, this.selectedLum.ledModelo).subscribe(result => {
        //this.restartImages();
        this.valid = false;
      });
    } else {
      this.selectedLum.ledModelo = "0";
      this.setModelByImagenesLuminaria(undefined);
      this.luminariaService.updateLedModelo(this.selectedLum.idDispositivo, "0").subscribe(result => {
        //this.restartImages();
        this.valid = false;
      });
    }
  }

  getModelList(): Model[] {
    return modelList;
  }

  private calculateLumSubIcon(luminaria: luminaria) {
    if(this.isUnconnected(luminaria) === 1) {
      return SubIcon.UNCONNECTED;
    }
    if(this.isWarning(luminaria)) {
      return SubIcon.WARNING;
    }

    const hasError = this.errorMap.get(luminaria.idDispositivo);
    if (hasError === true) {
      return SubIcon.ERROR;
    }

    return null;
  }

  private isUnconnected(luminaria: luminaria) {
    let now = new Date();
    if (luminaria.time_LAST_COM > 0) {
      if (((now.getTime() / 1000) - 86400) > luminaria.time_LAST_COM) {
        return 1;
      } else {
        return 0;
      }
    }
    return 1;
  }

  private isWarning(luminaria: luminaria) {
    return luminaria.perifericos != null && luminaria.perifericos.dali === 1;
  }

  private calculateImageSizeForLuminaria(luminaria: luminaria): { width: number; height: number } {
    const img = this.searchImageLumById(luminaria);


    const canvasWidth = this.ctxBack.canvas.width / this.adjustWidth;
    const canvasHeight = this.ctxBack.canvas.height / this.adjustHeight;

    if (!img || !img.naturalWidth || !img.naturalHeight) {
      return {
        width: this.widthLum,
        height: this.heightLum,
      };
    }

    const width = this.widthLum * img.naturalWidth * this.adjustFactor * this.ratio;
    const height = this.heightLum * img.naturalHeight * this.adjustFactor * this.ratio;

    return { width, height };
  }

}
